// extracted by mini-css-extract-plugin
export default {"slide":"components-Slide-slide-module__slide--cIPu1","img":"components-Slide-slide-module__img--VQtbJ"};